export const translation = {
  nav: {
    home: 'Home',
    products: 'Products',
    company: 'Company',
    downloads: 'Downloads',
    contact: 'Contact',
    news: 'News',
    language: 'Language',
    menu: 'Menu',
  },
  hero: {
    title: 'Manufacturing Machines with Modern Technology',
    subtitle: '"MADE IN GERMANY"!',
    description: 'We are a globally operating family business and a leading manufacturer of pointing machines, straightening machines, wire payoffs, de-coiling and feeding units for pointing machines.',
    description2: 'From design to commissioning, we offer customers all over the world high-tech products for the processing of wire, bars and tubes.',
  },
  contactSection: {
    title: 'Your Contact to Us:',
    phone: 'Tel.:',
    phoneNumber: '+49 (0) 2351 / 5 21 33',
    email: 'Or by email:',
    emailAddress: 'sales@bock-mf.de',
  },
  products: {
    title: 'Our Products',
    subtitle: 'High-tech machinery for wire, bar and tube processing',
    pointingMachines: 'Pointing Machines',
    pointingMachinesDesc: 'Precision machines for wire pointing operations',
    straighteningMachines: 'Straightening Machines',
    straighteningMachinesDesc: 'High-quality straightening equipment for various materials',
    wirePayoffs: 'Wire Payoffs',
    wirePayoffsDesc: 'Efficient wire handling and feeding systems',
    deCoiling: 'De-coiling & Feeding',
    deCoilingDesc: 'Automated de-coiling and feeding units for pointing machines',
  },
  about: {
    title: 'About Us',
    subtitle: 'A family business with worldwide operations',
    description: 'Maschinenfabrik Bock GmbH & Co. KG is a globally operating family business with representatives in many countries, which has developed into a leading manufacturer of pointing machines with different technologies.',
    quality: 'Know-how',
    qualityDesc: 'Our entire team is highly qualified. The use of state-of-the-art machines and CAD technologies guarantees production processes at the highest level.',
    innovation: 'Individuality',
    innovationDesc: 'We build exactly the machines you need. Individual solutions are our specialty.',
    worldwide: 'Personal Consultation',
    worldwideDesc: 'Our success is the result of personality, humanity and technical skill.',
  },
  footer: {
    imprint: 'Imprint',
    sitemap: 'Sitemap',
    contact: 'Contact',
    privacy: 'Privacy',
    privacySettings: 'Privacy Settings',
    print: 'Print',
    copyright: 'Maschinenfabrik Bock GmbH & Co. KG',
    youtube: 'YouTube',
    madeInGermany: 'Made in Germany',
  },
  contactPage: {
    title: 'Contact',
    phone: 'Phone',
    fax: 'Fax',
    faxNumber: '+49 (0) 2351 / 5 26 70',
    email: 'Email',
    address: 'Address',
    addressLine1: 'Maschinenfabrik Bock GmbH & Co. KG',
    addressLine2: 'Altenaer Straße 170',
    addressLine3: 'D-58513 Lüdenscheid, Germany',
    managingDirector: 'Dipl.-Ing. Karsten Bock - Managing Director',
    administration: 'Jutta Kordt-Bock - Administration',
    team: 'Contact Persons',
  },
  productsPage: {
    title: 'Products',
    subtitle: 'Machines for wire, bar and tube processing',
    pointingWire: 'Pointing Machines for Wire',
    pointingWireDesc: 'Our pointing machines for wire are designed for highest precision and efficiency.',
    pointingBars: 'Pointing Machines for Bars',
    pointingBarsDesc: 'Robust pointing machines for bars and tubes.',
    straightening: 'Straightening Machines',
    straighteningDesc: 'High-performance straightening machines for wire, bars and tubes.',
    payoffs: 'Wire Payoffs & De-coiling',
    payoffsDesc: 'Automated wire payoffs and de-coiling units.',
    feeding: 'Feeding Units',
    feedingDesc: 'Precision feeding units for automatic material supply.',
  },
  newsPage: {
    title: 'News',
    subtitle: 'Always up to date! We offer you interesting information from the market and about technical developments from our company.',
    readMore: 'Read more',
  },
  downloadsPage: {
    title: 'Downloads',
    subtitle: 'Brochures, technical documents and catalogs',
    catalogs: 'Product Catalogs',
    technicalDocs: 'Technical Documentation',
    certificates: 'Certificates',
  },
  impressumPage: {
    title: 'Legal Notice',
  },
  datenschutzPage: {
    title: 'Privacy Policy',
  },
  notFound: {
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist.',
    backHome: 'Back to Home',
  },
  common: {
    learnMore: 'Learn more',
    viewAll: 'View all',
    madeInGermany: 'Made in Germany',
  },
};

export default translation;